import { render, staticRenderFns } from "./CellTemplate.vue?vue&type=template&id=3ba4167b&scoped=true"
import script from "./CellTemplate.vue?vue&type=script&lang=ts"
export * from "./CellTemplate.vue?vue&type=script&lang=ts"
import style0 from "./CellTemplate.vue?vue&type=style&index=0&id=3ba4167b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba4167b",
  null
  
)

export default component.exports